// import { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import api from "../api";

// const emptyForm = {
//   emp_code: "",
//   first_name: "",
//   last_name: "",
//   email: "",
//   phone: "",
//   designation: "",
//   department: "",
//   date_of_birth: "",
//   date_of_joining: "",
//   pan: "",
//   bank_name: "",
//   account_no: "",
//   ifsc_code: "",
//   tax_regime: "New",
//   basic_monthly: "",
//   hra_monthly: "",
//   special_allowance_monthly: "",
//   lta_monthly: "",
// };

// const EmployeeForm = ({ mode }) => {
//   const [form, setForm] = useState(emptyForm);
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();
//   const params = useParams();
//   const isEdit = mode === "edit";

//   useEffect(() => {
//     const loadEmployee = async () => {
//       if (!isEdit) return;
//       try {
//         const res = await api.get(`/employees/${params.id}`);
//         const data = res.data;

//         setForm({
//           ...emptyForm,
//           ...data,
//           date_of_birth: data.date_of_birth
//             ? data.date_of_birth.slice(0, 10)
//             : "",
//           date_of_joining: data.date_of_joining
//             ? data.date_of_joining.slice(0, 10)
//             : "",
//         });
//       } catch (err) {
//         console.error(err);
//         alert("Error loading employee");
//       }
//     };
//     loadEmployee();
//   }, [isEdit, params.id]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((f) => ({ ...f, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       const payload = {
//         ...form,
//         basic_monthly: Number(form.basic_monthly) || 0,
//         hra_monthly: Number(form.hra_monthly) || 0,
//         special_allowance_monthly:
//           Number(form.special_allowance_monthly) || 0,
//         lta_monthly: Number(form.lta_monthly) || 0,
//       };

//       if (isEdit) {
//         await api.put(`/employees/${params.id}`, payload);
//       } else {
//         await api.post("/employees", payload);
//       }
//       navigate("/employees");
//     } catch (err) {
//       console.error(err);
//       alert("Error saving employee");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const grossMonthly =
//     (Number(form.basic_monthly) || 0) +
//     (Number(form.hra_monthly) || 0) +
//     (Number(form.special_allowance_monthly) || 0) +
//     (Number(form.lta_monthly) || 0);

//   return (
//     <div className="employee-form-shell">
//       {/* Header */}
//       <div className="employee-form-header">
//         <div>
//           <h1 className="employee-form-title">
//             {isEdit ? "Edit Employee" : "Add Employee"}
//           </h1>
//           <p className="employee-form-subtitle">
//             Capture employee master data and monthly salary breakup.
//           </p>
//         </div>
//         <button
//           type="button"
//           className="btn-secondary"
//           onClick={() => navigate("/employees")}
//         >
//           ← Back to Employees
//         </button>
//       </div>

//       {/* Form card */}
//       <div className="employee-form-card">
//         <form onSubmit={handleSubmit}>
//           {/* Section: Basic details */}
//           <div className="form-section">
//             <div className="form-section-header">
//               <h3>Basic Information</h3>
//               <p>Employee identity and organisation mapping.</p>
//             </div>
//             <div className="form-grid-3">
//               <div className="field">
//                 <label className="field-label">Employee Code *</label>
//                 <input
//                   className="field-input"
//                   name="emp_code"
//                   value={form.emp_code}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>
//               <div className="field">
//                 <label className="field-label">First Name *</label>
//                 <input
//                   className="field-input"
//                   name="first_name"
//                   value={form.first_name}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>
//               <div className="field">
//                 <label className="field-label">Last Name</label>
//                 <input
//                   className="field-input"
//                   name="last_name"
//                   value={form.last_name}
//                   onChange={handleChange}
//                 />
//               </div>
//             </div>

//             <div className="form-grid-3">
//               <div className="field">
//                 <label className="field-label">Designation</label>
//                 <input
//                   className="field-input"
//                   name="designation"
//                   value={form.designation}
//                   onChange={handleChange}
//                 />
//               </div>
//               <div className="field">
//                 <label className="field-label">Department</label>
//                 <input
//                   className="field-input"
//                   name="department"
//                   value={form.department}
//                   onChange={handleChange}
//                 />
//               </div>
//               <div className="field">
//                 <label className="field-label">Tax Regime</label>
//                 <select
//                   className="field-input"
//                   name="tax_regime"
//                   value={form.tax_regime}
//                   onChange={handleChange}
//                 >
//                   <option value="New">New</option>
//                   <option value="Old">Old</option>
//                 </select>
//               </div>
//             </div>
//           </div>

//           {/* Section: Contact */}
//           <div className="form-section">
//             <div className="form-section-header">
//               <h3>Contact Details</h3>
//               <p>Reachability information for payslip and communication.</p>
//             </div>
//             <div className="form-grid-2">
//               <div className="field">
//                 <label className="field-label">Email *</label>
//                 <input
//                   type="email"
//                   className="field-input"
//                   name="email"
//                   value={form.email}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>
//               <div className="field">
//                 <label className="field-label">Phone</label>
//                 <input
//                   className="field-input"
//                   name="phone"
//                   value={form.phone}
//                   onChange={handleChange}
//                 />
//               </div>
//             </div>

//             <div className="form-grid-2">
//               <div className="field">
//                 <label className="field-label">Date of Birth</label>
//                 <input
//                   type="date"
//                   className="field-input"
//                   name="date_of_birth"
//                   value={form.date_of_birth}
//                   onChange={handleChange}
//                 />
//               </div>
//               <div className="field">
//                 <label className="field-label">Date of Joining</label>
//                 <input
//                   type="date"
//                   className="field-input"
//                   name="date_of_joining"
//                   value={form.date_of_joining}
//                   onChange={handleChange}
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Section: Compliance / Bank */}
//           <div className="form-section">
//             <div className="form-section-header">
//               <h3>Compliance & Bank Details</h3>
//               <p>Used for payroll processing and statutory reporting.</p>
//             </div>

//             <div className="form-grid-3">
//               <div className="field">
//                 <label className="field-label">PAN</label>
//                 <input
//                   className="field-input"
//                   name="pan"
//                   value={form.pan}
//                   onChange={handleChange}
//                 />
//               </div>
//               <div className="field">
//                 <label className="field-label">Bank Name</label>
//                 <input
//                   className="field-input"
//                   name="bank_name"
//                   value={form.bank_name}
//                   onChange={handleChange}
//                 />
//               </div>
//               <div className="field">
//                 <label className="field-label">Account Number</label>
//                 <input
//                   className="field-input"
//                   name="account_no"
//                   value={form.account_no}
//                   onChange={handleChange}
//                 />
//               </div>
//             </div>

//             <div className="form-grid-3">
//               <div className="field">
//                 <label className="field-label">IFSC Code</label>
//                 <input
//                   className="field-input"
//                   name="ifsc_code"
//                   value={form.ifsc_code}
//                   onChange={handleChange}
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Section: Salary */}
//           <div className="form-section">
//             <div className="form-section-header form-section-header-row">
//               <div>
//                 <h3>Salary Structure (Monthly)</h3>
//                 <p>Fixed components that drive gross pay on the payslip.</p>
//               </div>
//               <div className="salary-summary-chip">
//                 <span>Estimated Gross</span>
//                 <strong>
//                   ₹{grossMonthly.toLocaleString("en-IN", { maximumFractionDigits: 0 })}
//                 </strong>
//               </div>
//             </div>

//             <div className="form-grid-2">
//               <div className="field">
//                 <label className="field-label">Basic *</label>
//                 <input
//                   type="number"
//                   className="field-input"
//                   name="basic_monthly"
//                   value={form.basic_monthly}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>
//               <div className="field">
//                 <label className="field-label">HRA *</label>
//                 <input
//                   type="number"
//                   className="field-input"
//                   name="hra_monthly"
//                   value={form.hra_monthly}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>
//             </div>

//             <div className="form-grid-2">
//               <div className="field">
//                 <label className="field-label">Special Allowance *</label>
//                 <input
//                   type="number"
//                   className="field-input"
//                   name="special_allowance_monthly"
//                   value={form.special_allowance_monthly}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>
//               <div className="field">
//                 <label className="field-label">Leave & Travel Allowance (LTA) *</label>
//                 <input
//                   type="number"
//                   className="field-input"
//                   name="lta_monthly"
//                   value={form.lta_monthly}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>
//             </div>
//           </div>

          

//           {/* Actions */}
//           <div className="employee-form-actions">
//             <button
//               className="btn-primary-large"
//               type="submit"
//               disabled={loading}
//             >
//               {loading ? "Saving…" : "Save Employee"}
//             </button>
//             <button
//               type="button"
//               className="btn-secondary"
//               onClick={() => navigate("/employees")}
//             >
//               Cancel
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default EmployeeForm;







import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../api";

const emptyForm = {
  emp_code: "",
  first_name: "",
  last_name: "",
  email: "",
  phone: "",
  designation: "",
  department: "",
  date_of_birth: "",
  date_of_joining: "",
  pan: "",
  bank_name: "",
  account_no: "",
  ifsc_code: "",
  tax_regime: "New",
  basic_monthly: "",
  hra_monthly: "",
  special_allowance_monthly: "",
  lta_monthly: "",

  // Manager metadata
  is_manager: false,
  manager_id: "",

  // 🔐 Added portal login fields
  portal_username: "",
  portal_password: "",
};

const EmployeeForm = ({ mode }) => {
  const [form, setForm] = useState(emptyForm);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const params = useParams();
  const isEdit = mode === "edit";

  const [employeeId, setEmployeeId] = useState(null); // needed for saving portal login
  const [managers, setManagers] = useState([]);

  useEffect(() => {
    const loadNextCode = async () => {
      if (isEdit) return;
      try {
        const res = await api.get("/employees/next-code");
        const next = res.data?.next_code || "";
        if (next) {
          setForm((f) => ({ ...f, emp_code: next }));
        }
      } catch (err) {
        console.error("Error fetching next employee code", err);
      }
    };
    loadNextCode();
  }, [isEdit]);

  useEffect(() => {
    const loadEmployee = async () => {
      if (!isEdit) return;
      try {
        const res = await api.get(`/employees/${params.id}`);
        const data = res.data;

        setEmployeeId(data.id);

        setForm({
          ...emptyForm,
          ...data,
          date_of_birth: data.date_of_birth
            ? data.date_of_birth.slice(0, 10)
            : "",
          date_of_joining: data.date_of_joining
            ? data.date_of_joining.slice(0, 10)
            : "",

          is_manager: !!data.is_manager,
          manager_id: data.manager_id || "",

          // Pre-fill login username as email
          portal_username: data.portal_username || data.email || "",
        });
      } catch (err) {
        console.error(err);
        alert("Error loading employee");
      }
    };
    const loadManagers = async () => {
      try {
        // Fetch only employees marked as managers
        const res = await api.get("/employees/managers");
        setManagers(res.data || []);
      } catch (err) {
        console.error("Managers load error", err);
      }
    };

    loadEmployee();
    loadManagers();
  }, [isEdit, params.id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleBooleanChange = (e) => {
    const { name, checked } = e.target;
    setForm((f) => ({ ...f, [name]: checked }));
  };

  // 🔐 Save portal login credentials
  const savePortalUser = async (emp_id) => {
    if (!form.portal_username || !form.portal_password) return;

    try {
      await api.post("/portal-users", {
        emp_id,
        username: form.portal_username,
        password: form.portal_password,
      });
    } catch (err) {
      console.error(err);
      alert("Error saving employee portal login");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        ...form,
        basic_monthly: Number(form.basic_monthly) || 0,
        hra_monthly: Number(form.hra_monthly) || 0,
        special_allowance_monthly:
          Number(form.special_allowance_monthly) || 0,
        lta_monthly: Number(form.lta_monthly) || 0,

        manager_id: form.manager_id || null,
        is_manager: !!form.is_manager,
      };

      let savedId = employeeId;

      if (isEdit) {
        await api.put(`/employees/${params.id}`, payload);
      } else {
        const res = await api.post("/employees", payload);
        savedId = res.data.id;
        setEmployeeId(savedId);
      }

      // 🔐 Save portal login
      await savePortalUser(savedId);

      navigate("/employees");
    } catch (err) {
      console.error(err);
      alert("Error saving employee");
    } finally {
      setLoading(false);
    }
  };

  const grossMonthly =
    (Number(form.basic_monthly) || 0) +
    (Number(form.hra_monthly) || 0) +
    (Number(form.special_allowance_monthly) || 0) +
    (Number(form.lta_monthly) || 0);

  return (
    <div className="employee-form-shell">
      {/* Header */}
      <div className="employee-form-header">
        <div>
          <h1 className="employee-form-title">
            {isEdit ? "Edit Employee" : "Add Employee"}
          </h1>
          <p className="employee-form-subtitle">
            Capture employee master data and monthly salary breakup.
          </p>
        </div>
        <button
          type="button"
          className="btn-secondary"
          onClick={() => navigate("/employees")}
        >
          ← Back to Employees
        </button>
      </div>

      {/* Form card */}
      <div className="employee-form-card">
        <form onSubmit={handleSubmit}>
          {/* Section: Basic details */}
          <div className="form-section">
            <div className="form-section-header">
              <h3>Basic Information</h3>
              <p>Employee identity and organisation mapping.</p>
            </div>
            <div className="form-grid-3">
              <div className="field">
                <label className="field-label">Employee Code *</label>
                <input
                  className="field-input"
                  name="emp_code"
                  value={form.emp_code}
                  onChange={handleChange}
                  required
                  readOnly={!isEdit}
                />
              </div>
              <div className="field">
                <label className="field-label">First Name *</label>
                <input
                  className="field-input"
                  name="first_name"
                  value={form.first_name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="field">
                <label className="field-label">Last Name</label>
                <input
                  className="field-input"
                  name="last_name"
                  value={form.last_name}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="form-grid-3">
              <div className="field">
                <label className="field-label">Designation</label>
                <input
                  className="field-input"
                  name="designation"
                  value={form.designation}
                  onChange={handleChange}
                />
              </div>
              <div className="field">
                <label className="field-label">Department</label>
                <input
                  className="field-input"
                  name="department"
                  value={form.department}
                  onChange={handleChange}
                />
              </div>
              <div className="field">
                <label className="field-label">Tax Regime</label>
                <select
                  className="field-input"
                  name="tax_regime"
                  value={form.tax_regime}
                  onChange={handleChange}
                >
                  <option value="New">New</option>
                  <option value="Old">Old</option>
                </select>
              </div>
            </div>

            <div className="form-grid-3">
              <div className="field checkbox-field">
                <label className="field-label">Is Manager</label>
                <label className="switch">
                  <input
                    type="checkbox"
                    name="is_manager"
                    checked={!!form.is_manager}
                    onChange={handleBooleanChange}
                  />
                  <span className="slider round"></span>
                </label>
              </div>

              <div className="field">
                <label className="field-label">Reports To</label>
                <select
                  className="field-input"
                  name="manager_id"
                  value={form.manager_id || ""}
                  onChange={handleChange}
                >
                  <option value="">None</option>
                  {managers.map((m) => (
                    <option key={m.id} value={m.id}>
                      {m.emp_code} - {m.first_name} {m.last_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* Section: Contact */}
          <div className="form-section">
            <div className="form-section-header">
              <h3>Contact Details</h3>
              <p>Reachability information for payslip and communication.</p>
            </div>
            <div className="form-grid-2">
              <div className="field">
                <label className="field-label">Email *</label>
                <input
                  type="email"
                  className="field-input"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="field">
                <label className="field-label">Phone</label>
                <input
                  className="field-input"
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="form-grid-2">
              <div className="field">
                <label className="field-label">Date of Birth</label>
                <input
                  type="date"
                  className="field-input"
                  name="date_of_birth"
                  value={form.date_of_birth}
                  onChange={handleChange}
                />
              </div>
              <div className="field">
                <label className="field-label">Date of Joining</label>
                <input
                  type="date"
                  className="field-input"
                  name="date_of_joining"
                  value={form.date_of_joining}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          {/* Section: Compliance / Bank */}
          <div className="form-section">
            <div className="form-section-header">
              <h3>Compliance & Bank Details</h3>
              <p>Used for payroll processing and statutory reporting.</p>
            </div>

            <div className="form-grid-3">
              <div className="field">
                <label className="field-label">PAN</label>
                <input
                  className="field-input"
                  name="pan"
                  value={form.pan}
                  onChange={handleChange}
                />
              </div>
              <div className="field">
                <label className="field-label">Bank Name</label>
                <input
                  className="field-input"
                  name="bank_name"
                  value={form.bank_name}
                  onChange={handleChange}
                />
              </div>
              <div className="field">
                <label className="field-label">Account Number</label>
                <input
                  className="field-input"
                  name="account_no"
                  value={form.account_no}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="form-grid-3">
              <div className="field">
                <label className="field-label">IFSC Code</label>
                <input
                  className="field-input"
                  name="ifsc_code"
                  value={form.ifsc_code}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          {/* Section: Salary */}
          <div className="form-section">
            <div className="form-section-header form-section-header-row">
              <div>
                <h3>Salary Structure (Monthly)</h3>
                <p>Fixed components that drive gross pay on the payslip.</p>
              </div>
              <div className="salary-summary-chip">
                <span>Estimated Gross</span>
                <strong>
                  ₹{grossMonthly.toLocaleString("en-IN", {
                    maximumFractionDigits: 0,
                  })}
                </strong>
              </div>
            </div>

            <div className="form-grid-2">
              <div className="field">
                <label className="field-label">Basic *</label>
                <input
                  type="number"
                  className="field-input"
                  name="basic_monthly"
                  value={form.basic_monthly}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="field">
                <label className="field-label">HRA *</label>
                <input
                  type="number"
                  className="field-input"
                  name="hra_monthly"
                  value={form.hra_monthly}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="form-grid-2">
              <div className="field">
                <label className="field-label">Special Allowance *</label>
                <input
                  type="number"
                  className="field-input"
                  name="special_allowance_monthly"
                  value={form.special_allowance_monthly}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="field">
                <label className="field-label">Leave & Travel Allowance (LTA) *</label>
                <input
                  type="number"
                  className="field-input"
                  name="lta_monthly"
                  value={form.lta_monthly}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
          </div>

          {/* 🔐 PORTAL LOGIN SECTION */}
          <div className="form-section">
            <div className="form-section-header">
              <h3>Portal Login Credentials</h3>
              <p>Enable the employee to access their payslip dashboard.</p>
            </div>

            <div className="form-grid-2">
              <div className="field">
                <label className="field-label">Login Username</label>
                <input
                  className="field-input"
                  name="portal_username"
                  placeholder="Usually their email"
                  value={form.portal_username}
                  onChange={handleChange}
                />
              </div>
              <div className="field">
                <label className="field-label">Login Password</label>
                <input
                  type="password"
                  className="field-input"
                  name="portal_password"
                  placeholder="Set a new password"
                  value={form.portal_password}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          {/* END LOGIN SECTION */}

          {/* Actions */}
          <div className="employee-form-actions">
            <button
              className="btn-primary-large"
              type="submit"
              disabled={loading}
            >
              {loading ? "Saving…" : "Save Employee"}
            </button>
            <button
              type="button"
              className="btn-secondary"
              onClick={() => navigate("/employees")}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EmployeeForm;
